module.exports = __webpack_public_path__ + "static/media/resume-eric-nunez.411cd089.pdf";